import React from 'react';
import { IAddress } from '../../../../generated/graphql';
import PaperCard from '../../../Common/Layout/PaperCard';
import AddressForm from './AddressForm';

interface IProps {
  handleClose: () => void;
  address: IAddress;
  handleEdit: (address: IAddress) => void;
}

const AddressDetails: React.FunctionComponent<IProps> = ({
  handleClose,
  address,
  handleEdit
}: IProps) => {
  return (
    <PaperCard
      headerText="Details"
      width="82%"
      additionalStyle={{ height: '680px' }}
      navigationButton={{
        id: 'Back-to-Addresses',
        text: 'Addresses',
        onClick: handleClose
      }}
    >
      <AddressForm addressInput={address} handleClose={handleClose} updateList={handleEdit} />
    </PaperCard>
  );
};

export default AddressDetails;
